import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import PrimeButton from "./PrimeButton";

const pages = [
  { page: "Home", path: "/" },
  { page: "About Us", path: "/about-us" },
  { page: "Services", path: "/service" },
  { page: "Products", path: "/product" },
  { page: "Contact Us", path: "/contact-us" },
  { page: "News & Events", path: "/news" },
];

export default function Navbar({ transparent = false }) {
  const [isNavbarTransparent, setIsNavbarTransparent] = useState(false);
  const [open,setOpen] = useState(false);

  const handleScroll = () => {
    setIsNavbarTransparent(window.scrollY > 50);
  };

  const openMenu =()=> setOpen(prev=> !prev);
  

  const activeLinkHandler = ({ isActive }) => {
    return isActive ? { color: "#005CB9" } : {};
  };

  useEffect(() => {
    if (transparent) {
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);

  return (
    <nav
      className={`navbar fixed w-full z-50 top-0 start-0  h-[96px] items-center lg:px-10     ${
        isNavbarTransparent
          ? "bg-black duration-700 text-white"
          : "bg-white duration-700 text-black"
      }`}
    >
      <div className="max-w-screen-xl h-full flex flex-wrap items-center justify-between mx-auto py-4  ">
        <NavLink
          to="/"
          className="flex items-center space-x-3 rtl:space-x-reverse w-[15%] ml-5 lg:ml-0"
        >
          <img
            // src={require("../assets/logo.png")}
            src={require("../assets/logo.png")}
            className="h-4/5"
            alt="H2A Logo"
          />
        </NavLink>

        <div className="flex lg:order-2 space-x-3 lg:space-x-0 rtl:space-x-reverse  mr-5 lg:ml-0">
          <button

            data-collapse-toggle="navbar-sticky"
            onClick={openMenu}
            type="button"
            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            aria-controls="navbar-sticky"
            aria-expanded="false"
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 17 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>
        </div>
        <div
          className={`absolute top-[94px]  lg:static  items-center justify-between  ${!open && "hidden"} w-full lg:flex lg:w-[85%] md:order-1`}
          id="navbar-sticky"
        >
          {/* You can add your navigation items here */}
          <ul
            className={`flex flex-col gap-2  items-center text-nowrap lg:p-0 font-medium w-full lg:flex-row lg:mt-0 lg:border-0  ${
              isNavbarTransparent
                ? "bg-black duration-700"
                : "bg-white duration-700"
            }`}
          >
            {pages.map((p, index) => (
              <li
                key={index}
                className="w-full text-center hover:cursor-pointer hover:bg-primary-color/30 lg:hover:bg-transparent"
                onClick={()=> setOpen(false)}
              >
                <NavLink
                  style={activeLinkHandler}
                  className={`font-medium ${
                    isNavbarTransparent ? "text-white" : "text-gray-600"
                  } w-full block`}
                  key={index}
                  to={p.path}
                >
                  {p.page}
                </NavLink>
              </li>
            ))}
            <div className="flex m-3 items-center">
            <li className="w-full mx-3">
              <PrimeButton size="text-lg lg:text-lg" full={true} />
            </li>
            <li className="w-full mx-3">
              <a target="_blank" href="https://www.linkedin.com/company/h2a-medical-solutions/" className="text-3xl text-blue-800 hover:text-blue-500"><i className="fa-brands fa-linkedin"></i></a>
            </li>
            </div>
          </ul>
        </div>
      </div>
    </nav>
  );
}
